var _circle, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _circle2, _path3, _rect15, _rect16, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.1016,
    r: 80,
    fill: "currentcolor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9277 104.961H114.894V108.055L104.58 110.634H44.2419L33.9277 108.055V104.961Z",
    fill: "#909196"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0547 67.0625C38.0547 62.6442 41.6364 59.0625 46.0547 59.0625H107.285C109.495 59.0625 111.285 60.8534 111.285 63.0625V104.961H38.0547V67.0625Z",
    fill: "#BABBBE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.1152,
    y: 61.6367,
    width: 69.105,
    height: 41.7725,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7578,
    y: 85.3633,
    width: 3.09426,
    height: 15.987,
    rx: 1.54713,
    fill: "#8CD1FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.9141,
    y: 76.5938,
    width: 3.09426,
    height: 24.754,
    rx: 1.54713,
    fill: "#8CD1FC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.0703,
    y: 80.207,
    width: 3.09426,
    height: 21.1441,
    rx: 1.54713,
    fill: "#8CD1FC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60.2305,
    y: 84.332,
    width: 3.09426,
    height: 17.0184,
    rx: 1.54713,
    fill: "#8CD1FC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 65.3867,
    y: 90.5195,
    width: 3.09426,
    height: 10.8299,
    rx: 1.54713,
    fill: "#8CD1FC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70.543,
    y: 80.207,
    width: 3.09426,
    height: 21.1441,
    rx: 1.54713,
    fill: "#8CD1FC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 75.6992,
    y: 72.4727,
    width: 3.09426,
    height: 28.8797,
    rx: 1.54713,
    fill: "#FFC300"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 80.8574,
    y: 64.7344,
    width: 3.09426,
    height: 36.6154,
    rx: 1.54713,
    fill: "#F9E7A1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 86.0156,
    y: 69.8906,
    width: 3.09426,
    height: 31.4583,
    rx: 1.54713,
    fill: "#B253B7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 91.1719,
    y: 87.4297,
    width: 3.09426,
    height: 13.9242,
    rx: 1.54713,
    fill: "#B253B7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 96.3281,
    y: 82.7852,
    width: 3.09426,
    height: 18.5655,
    rx: 1.54713,
    fill: "#8CD1FC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 101.486,
    y: 78.1445,
    width: 3.09426,
    height: 23.2069,
    rx: 1.54713,
    fill: "#8CD1FC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 66.418,
    y: 104.961,
    width: 15.4713,
    height: 1.03142,
    fill: "#E3E4E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.1733,
    cy: 53.1284,
    r: 20.8862,
    fill: "#FF9E5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2109 39.6585L49.7916 53.3863L50.3165 32.2427C50.269 32.2423 50.2215 32.2422 50.1739 32.2422C43.7717 32.2422 38.0422 35.1228 34.2109 39.6585Z",
    fill: "#F8E6A5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 110.762,
    y: 110.766,
    width: 3.8322,
    height: 7.11694,
    transform: "rotate(-45 110.762 110.766)",
    fill: "#FFE190"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 113.01,
    y: 114.27,
    width: 5.79114,
    height: 19.9934,
    rx: 2.89557,
    transform: "rotate(-44.2474 113.01 114.27)",
    fill: "#002D58"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21521_76195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 72,
    width: 44,
    height: 44
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.099 93.8668C119.099 104.306 110.636 112.769 100.197 112.769C89.7576 112.769 81.2949 104.306 81.2949 93.8668C81.2949 83.4275 89.7576 74.9648 100.197 74.9648C110.636 74.9648 119.099 83.4275 119.099 93.8668Z",
    stroke: "#002D58",
    strokeWidth: 5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21521_76195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.153 93.8696C129.153 109.861 116.189 122.825 100.198 122.825C84.206 122.825 71.2422 109.861 71.2422 93.8696C71.2422 77.8779 84.206 64.9141 100.198 64.9141C116.189 64.9141 129.153 77.8779 129.153 93.8696Z",
    fill: "#002D58"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInfo);
export default __webpack_public_path__ + "static/media/search_info.b23318733337b141cf0b1bd659ee839c.svg";
export { ForwardRef as ReactComponent };